import { createContext } from "react";
function initialLoadableValue() {
    return {
        updatedAt: null,
        loading: false,
        value: null,
        error: undefined,
    };
}
export const initialContextValue = {
    client: undefined,
    state: {
        accounts: initialLoadableValue(),
        currencies: initialLoadableValue(),
        capabilities: initialLoadableValue(),
        walletInfo: initialLoadableValue(),
        userId: initialLoadableValue(),
    },
    setState: () => {
        return;
    },
};
export const WalletAPIProviderContext = createContext(initialContextValue);
//# sourceMappingURL=context.js.map